import React from "react";

import css from "./DateInput.module.scss";
import { Props } from "@greeter/matter";
import { classNames } from "@greeter/util";

function formatDate(date: Date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // getMonth() is zero-based
  const day = date.getDate();

  // Pad the month and day with leading zeros if needed
  const monthString = month < 10 ? "0" + month : month;
  const dayString = day < 10 ? "0" + day : day;

  return `${year}-${monthString}-${dayString}`;
}

export type DateInputProps = Props & {
  value: Date;
  onChange: (d: Date) => void;
  theme?: "dark" | "light";
};

export function DateInput(props: DateInputProps) {
  return (
    <input
      type="date"
      {...classNames(
        css.DateInput,
        props.theme === "dark" && css.Dark,
        props.className
      )}
      value={formatDate(props.value)}
      onChange={(e) => props.onChange(new Date(e.currentTarget.value))}
      style={props.style}
      children={props.children}
    />
  );
}
